import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { I18n, CustomDatepickerI18n } from '../datepicker-ita/datepicker-ita.component';

/**
 * Datepicker generico "pill" a data singola.
 *
 * Sostituisce i vecchi wrapper ngbd-datepicker-* che differivano solo per il
 * metodo di conferma chiamato. La logica resta nel chiamante: il genitore lega
 * la data con [(date)] e reagisce alla conferma con (confirm).
 *
 * Esempi:
 *   <sb-datepicker [(date)]="globalData.datePicker.dataSelezionata"
 *                  (confirm)="globalData.aggiornaCalendarioRistorante($event)">
 *
 *   <!-- stagione: conferma anche al cambio data, disabilita se vuoto -->
 *   <sb-datepicker [(date)]="globalData.datePicker.dataSelezionata"
 *                  [confirmDisabledWhenEmpty]="true" [confirmOnChange]="true"
 *                  (confirm)="globalData.aggiornaDataInizioStagione($event)">
 */
@Component({
  selector: 'sb-datepicker',
  templateUrl: './sb-datepicker.component.html',
  providers: [I18n, { provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n }],
  standalone: false
})
export class SbDatepickerComponent {
  /** Data legata — two-way [(date)] */
  @Input() date: NgbDateStruct;
  @Output() dateChange = new EventEmitter<NgbDateStruct>();

  /** Emesso al click su Conferma (e al cambio data se confirmOnChange) */
  @Output() confirm = new EventEmitter<NgbDateStruct>();

  @Input() placeholder = 'gg-mm-aaaa';
  @Input() minDate: NgbDateStruct;
  @Input() confirmDisabledWhenEmpty = false;
  /** Se true, ogni selezione di data emette anche confirm (replica il vecchio ngModelChange) */
  @Input() confirmOnChange = false;

  onDateChange(value: NgbDateStruct) {
    this.date = value;
    this.dateChange.emit(value);
    if (this.confirmOnChange) {
      this.confirm.emit(value);
    }
  }
}
